module.exports = __webpack_public_path__ + "img/settings.f6ae744f.svg";